import axios from 'axios';

import routes from 'app/routes';

export default {
  loadPolicy: (dispatch, enterpriseId) => {
    dispatch({
      type: 'LOAD_POLICY',
      policy: null,
    });

    axios
      .get(routes.api.enterprises.policy(enterpriseId))
      .then((response) => {
        dispatch({
          type: 'LOAD_POLICY',
          policy: response.data.data,
        });
      });
  },

  loadPaymentMethods: (dispatch) => {
    dispatch({
      type: 'LOAD_PAYMENT_METHODS',
      paymentMethods: null,
    });
    axios
      .get(routes.api.managers.payment_methods.index)
      .then((response) => {
        dispatch({
          type: 'LOAD_PAYMENT_METHODS',
          paymentMethods: response.data.data,
        });
      });
  },

  prepareBillingInformation: (callback) => {
    axios
      .get(routes.api.managers.payment_methods.new)
      .then((resp) => {
        callback(resp.data.data);
      });
  },

  addOrUpdatePaymentMethod: (dispatch, paymentMethod) => {
    dispatch({ type: 'ADD_OR_UPDATE_PAYMENT_METHOD', paymentMethod });
  },

  savePaymentMethod: (dispatch, paymentMethodId, values, successCallback, errorCallback) => {
    const createPaymentMethod = () => axios
      .post(routes.api.managers.payment_methods.create, {
        payment_information: values,
      });

    const updatePaymentMethod = () => axios
      .put(routes.api.managers.payment_methods.update(paymentMethodId), {
        payment_information: values,
      });

    const request = paymentMethodId === ''
      ? createPaymentMethod()
      : updatePaymentMethod();

    request.then((resp) => {
      dispatch({ type: 'ADD_OR_UPDATE_PAYMENT_METHOD', paymentMethod: resp.data.data });
      successCallback();
    })
      .catch((error, _data) => {
        errorCallback(error.response.data.errors);
      });
  },
  deletePaymentMethod: (dispatch, paymentMethodId, callback) => {
    axios
      .delete(routes.api.managers.payment_methods.delete(paymentMethodId))
      .then((_resp) => {
        dispatch({ type: 'DELETE_PAYMENT_METHOD', paymentMethodId });
        callback();
      });
  },
  deleteLinkedPaymentMethod: (dispatch, paymentMethodId, errorCallback) => {
    axios
      .post(routes.api.managers.payment_methods.detach(paymentMethodId))
      .then((resp) => {
        dispatch({ type: 'ADD_OR_UPDATE_PAYMENT_METHOD', paymentMethod: resp.data.data });
      })
      .catch((error, _data) => {
        errorCallback(error.response.data.errors);
      });
  },
  assignPaymentMethods: (values, callback) => {
    axios
      .post(routes.api.managers.payment_methods.assign, { ...values })
      .then((_resp) => {
        callback();
      });
  },
};
